import { BaseLandscapeService } from '../../base-landscape.service';
import { LandscapeContactPersonResponseDto } from '../dto/response/landscape-contact-person-response.dto';
import { LandscapeContactPersonSaveRequestDto } from '../dto/request/landscape-contact-person-save-request.dto';
import { LandscapeContactPersonUpdateRequestDto } from '../dto/request/landscape-contact-person-update-request.dto';

class LandscapeContactPersonService extends BaseLandscapeService {
  public async fetchLandscapeContactPersons(): Promise<
    LandscapeContactPersonResponseDto[]
  > {
    const response = await this.get<LandscapeContactPersonResponseDto[]>(
      `/compactcontactperson`
    );
    return response.data;
  }

  public async fetchLandscapeContactPersonById(
    id: string
  ): Promise<LandscapeContactPersonResponseDto> {
    const response = await this.get<LandscapeContactPersonResponseDto>(
      `/compactcontactperson/${id}`
    );
    return response.data;
  }

  public async fetchLandscapeContactPersonsByLandscapeId(
    landscapeId: string
  ): Promise<LandscapeContactPersonResponseDto[]> {
    const response = await this.get<LandscapeContactPersonResponseDto[]>(
      `/compactcontactperson/bycompactid/${landscapeId}`
    );
    return response.data;
  }

  public async fetchLandscapeContactPersonsByProjectId(
    projectId: string
  ): Promise<LandscapeContactPersonResponseDto[]> {
    try {
      const response = await this.get<LandscapeContactPersonResponseDto[]>(
        `/compactcontactperson/byprojectid/${projectId}`
      );
      return response.data;
    } catch (e: any) {
      // The API returns 404 if no contact person is found in the project
      if (e.statusCode === 404) {
        return [];
      }
      return Promise.reject(e);
    }
  }

  public async saveLandscapeContactPerson(
    saveRequest: LandscapeContactPersonSaveRequestDto
  ): Promise<LandscapeContactPersonResponseDto> {
    const response = await this.post<LandscapeContactPersonResponseDto>(
      `/compactcontactperson`,
      saveRequest
    );
    return response.data;
  }

  public async updateLandscapeContactPerson(
    updateRequest: LandscapeContactPersonUpdateRequestDto
  ): Promise<LandscapeContactPersonResponseDto> {
    const response = await this.put<LandscapeContactPersonResponseDto>(
      `/compactcontactperson`,
      updateRequest
    );
    return response.data;
  }

  public async deleteLandscapeContactPerson(existingId: string): Promise<void> {
    await this.delete<void>(`/compactcontactperson/${existingId}`);
  }
}

const landscapeContactPersonService = new LandscapeContactPersonService();
export default landscapeContactPersonService;
